import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Injector, } from '@angular/core';
import { MapperService } from '@services/mapper.service';
import { BaseLicenseService } from 'main/app-state/current-user/license/base-license.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TenantLicenseService = /** @class */ (function (_super) {
    tslib_1.__extends(TenantLicenseService, _super);
    function TenantLicenseService(http, _injector) {
        var _this = _super.call(this, http, MapperService.licenseMap, _injector) || this;
        _this._injector = _injector;
        _this._endpoint = '/odata/Settings';
        _this._getEndpoint = '/odata/Settings/UiPath.Server.Configuration.OData.GetLicense';
        return _this;
    }
    TenantLicenseService.prototype.deleteLicense = function () {
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.DeleteLicense()", null);
    };
    TenantLicenseService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TenantLicenseService_Factory() { return new TenantLicenseService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.INJECTOR)); }, token: TenantLicenseService, providedIn: "root" });
    return TenantLicenseService;
}(BaseLicenseService));
export { TenantLicenseService };
